module.exports = __webpack_public_path__ + "img/ticket.75252f7d.svg";